export const LOCAL_AUTH_STORAGE_KEY = 'LOCAL_AUTH_STORAGE_KEY';
